import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAi'

export const servicesList = (params = '') => Http.get(`/admin/services${serialize(params)}`)
export const serviceCreate = (params = '') => Http.post('/admin/services', params)
export const serviceByID = (params = '') => Http.get(`/admin/services${params}`)
export const serviceUpdate = (params = '') => Http.put(`/admin/services/${params.id}`, params)
export const serviceDestroy = (params = '') => Http.delete(`/admin/services/${params.id}`)
